<template>
  <popup
    :visible="visible"
    :mask-click="maskClick"
    @onMaskClick="maskClickHandle"
  >
    <transition name="fade">
      <div v-if="visible" class="containter">
        <slot />
      </div>
    </transition>
  </popup>
</template>

<script type="babel">
import popup from './popup.vue';

export default {
  components: {
    popup,
  },
  props: {
    maskClick: {
      type: Boolean,
      default: false
    },
    visible: {
      default: false,
      type: Boolean,
    }
  },
  methods: {
    maskClickHandle() {
      this.$emit('onMaskClick');
    }
  }
}
</script>
<style lang="scss" scoped>
.containter {
  z-index: 1000;
  position: fixed;
  background: #fff;
  left: 50%;
  top: 50%;
  transform: translate(-50%, calc(-50% - 44px));
  width: 684px;
  box-sizing: border-box;
  padding: 32px 48px;
  border-radius: 40px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
